import { createStyles } from "antd-style";

export const useRequestFormViewStyles = createStyles(({ css }: any) => ({
  root: css``,
  header: css`
    button {
      min-width: 164px;
    }
  `,
}));
